export const TOTAL_HEADER_HEIGHT = 164;
export const MAIN_HEADER_HEIGHT = 50;
